/**
 * @Description:
 * @Author: huage
 * @Date: 2020/9/17
 */
export default {
    dataAuth: {
        "ruleTemplateName": "规则模板名称",
        "ruleName": "规则名称",
        "role": "角色",
        "ruleList": "规则列表",
        "ruleTemplateCode": "规则模板编号",
        "applicationExamples": "应用实例",
        "controlledObject": "受控实体",
        "state": "状态",
        "ruleCoding": "规则编码",
        "ruleEffectiveType": "规则生效类型",
        "roleOfRulesInEffect": "规则生效角色",
        "logicalConfiguration": "逻辑配置",
        "fieldName": "受控字段",
        "valueType": "取值类型",
        "logicalOperator": "逻辑运算符",
        "value": "字段的值",
        "addALine": "添加一行",
        "addGroup": "添加分组",
        "deleteGroup": "删除分组",
        "addRule": "新增规则",
        "action": "操作",
        "conditionalConfiguration": "条件配置",
        "select": "选择",
        "functionName": "函数名称",
        "code": "编码",
        "name": "名称",

        "message1": "编辑规则成功",
        "message2": "新增规则成功",
        "message3": "不能为空",
        "message4": "该字段没有设置关联表或关联字段，请选择其他取值类型",
        "message5": "该字段没有设置关联表，请选择其他取值类型",

        "text1": "选择系统默认",
        "text2": "选择函数",
        "text3": "选择其它关联表",
        "sceneCode": "场景标识"
      }
};


// WEBPACK FOOTER //
// ./src/config/langs/zh_CN/dataAuth.js